module.exports = __webpack_public_path__ + "static/media/shell32_37.e5028c51.ico";